"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = require("./Constants");
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var LinearScale_1 = require("./LinearScale");
var AdvDate_1 = require("../lib/AdvDate");
var AgePensionBasis = (function () {
    function AgePensionBasis() {
        this._maxFortnightlyPayment = null;
        this._incomeTest = null;
        this._assetTest = null;
        this._pensionSupplementMinimum = null;
        this._pensionSupplementMaximum = null;
        this._pensionSupplementUpperIncomeThreshold = null;
        this._pensionSupplementUpperAssetThreshold = null;
        this._deemingThreshold = null;
        this._WorkBonus = null;
        this._deemingRateLowerIncome = 0;
        this._deemingRateHigherIncome = 0;
        this._includeAgePension = false;
        this._singlePersonProjectionButAllowForBothAgePensions = false;
        this._isMarried = false;
        this._isHomeowner = false;
    }
    AgePensionBasis.isQualifyingAgeForAgePension = function (sex, dateBirth, age) {
        var qualifyingAge = 0;
        if (sex === "Male") {
            if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1952"))) {
                qualifyingAge = 65;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1954"))) {
                qualifyingAge = 65.5;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1955"))) {
                qualifyingAge = 66;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1957"))) {
                qualifyingAge = 66.5;
            }
            else {
                qualifyingAge = 67;
            }
        }
        else {
            if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1935"))) {
                qualifyingAge = 60;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1937"))) {
                qualifyingAge = 60.5;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1938"))) {
                qualifyingAge = 61;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1940"))) {
                qualifyingAge = 61.5;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1941"))) {
                qualifyingAge = 62;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1943"))) {
                qualifyingAge = 62.5;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1944"))) {
                qualifyingAge = 63;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1946"))) {
                qualifyingAge = 63.5;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1947"))) {
                qualifyingAge = 64;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1948"))) {
                qualifyingAge = 64.5;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1952"))) {
                qualifyingAge = 65;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1954"))) {
                qualifyingAge = 65.5;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/7/1955"))) {
                qualifyingAge = 66;
            }
            else if (dateBirth.before(new AdvDate_1.AdvDate("1/1/1957"))) {
                qualifyingAge = 66.5;
            }
            else {
                qualifyingAge = 67;
            }
        }
        if (age >= qualifyingAge) {
            return true;
        }
        else {
            return false;
        }
    };
    AgePensionBasis.prototype.initialise = function (p, isMarried, isHomeOwner, singlePersonProjection, allowForBothAgePensions, wageIndexation, priceIndexation) {
        var maxPayment;
        var incomeTestLowerThreshold;
        var incomeTestUpperThreshold;
        var assetTestLowerThreshold;
        var assetTestUpperThreshold;
        var pensionSupplementMaximum;
        var pensionSupplementMinimum;
        var deemingThreshold;
        var countOfRecipients;
        this._maxFortnightlyPayment = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._incomeTest = new LinearScale_1.LinearScale();
        this._assetTest = new LinearScale_1.LinearScale();
        this._pensionSupplementMinimum = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._pensionSupplementMaximum = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._pensionSupplementUpperIncomeThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._pensionSupplementUpperAssetThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._deemingThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._WorkBonus = new IndexedDollarParameter_1.IndexedDollarParameter();
        if (isMarried) {
            countOfRecipients = 2;
            maxPayment = p.getParamNumber("PensionCouple");
            pensionSupplementMaximum = p.getParamNumber("PensionSupplementCoupleMaximum");
            pensionSupplementMinimum = p.getParamNumber("PensionSupplementCoupleMinimum");
            incomeTestLowerThreshold = p.getParamNumber("IncomeTestLowerThresholdCouple");
            incomeTestUpperThreshold = p.getParamNumber("IncomeTestUpperThresholdCouple");
            if (isHomeOwner) {
                assetTestLowerThreshold = p.getParamNumber("AssetTestLowerThresholdCoupleHomeowner");
                assetTestUpperThreshold = p.getParamNumber("AssetTestUpperThresholdCoupleHomeowner");
            }
            else {
                assetTestLowerThreshold = p.getParamNumber("AssetTestLowerThresholdCoupleNonHomeowner");
                assetTestUpperThreshold = p.getParamNumber("AssetTestUpperThresholdCoupleNonHomeowner");
            }
            deemingThreshold = p.getParamNumber("DeemingThresholdCouple");
        }
        else {
            countOfRecipients = 1;
            maxPayment = p.getParamNumber("PensionSingle");
            pensionSupplementMaximum = p.getParamNumber("PensionSupplementSingleMaximum");
            pensionSupplementMinimum = p.getParamNumber("PensionSupplementSingleMinimum");
            incomeTestLowerThreshold = p.getParamNumber("IncomeTestLowerThresholdSingle");
            incomeTestUpperThreshold = p.getParamNumber("IncomeTestUpperThresholdSingle");
            if (isHomeOwner) {
                assetTestLowerThreshold = p.getParamNumber("AssetTestLowerThresholdSingleHomeowner");
                assetTestUpperThreshold = p.getParamNumber("AssetTestUpperThresholdSingleHomeowner");
            }
            else {
                assetTestLowerThreshold = p.getParamNumber("AssetTestLowerThresholdSingleNonHomeowner");
                assetTestUpperThreshold = p.getParamNumber("AssetTestUpperThresholdSingleNonHomeowner");
            }
            deemingThreshold = p.getParamNumber("DeemingThresholdSingle");
        }
        this._maxFortnightlyPayment.initialise(maxPayment, wageIndexation);
        this._incomeTest.initialise(incomeTestLowerThreshold * Constants.FORTNIGHTS_PER_YEAR, incomeTestUpperThreshold * Constants.FORTNIGHTS_PER_YEAR, priceIndexation);
        this._assetTest.initialise(assetTestLowerThreshold, assetTestUpperThreshold, priceIndexation);
        this._pensionSupplementMinimum.initialise(pensionSupplementMinimum, wageIndexation);
        this._pensionSupplementMaximum.initialise(pensionSupplementMaximum, wageIndexation);
        this._pensionSupplementUpperIncomeThreshold.initialise(incomeTestUpperThreshold * Constants.FORTNIGHTS_PER_YEAR, priceIndexation);
        this._pensionSupplementUpperAssetThreshold.initialise(assetTestUpperThreshold, priceIndexation);
        this._deemingThreshold.initialise(deemingThreshold, priceIndexation);
        this._deemingRateLowerIncome = p.getParamNumber("DeemingRateLowerIncome");
        this._deemingRateHigherIncome = p.getParamNumber("DeemingRateHigherIncome");
        this._WorkBonus.initialise(p.getParamNumber("WorkBonus"), wageIndexation);
        this._isMarried = isMarried;
        this._isHomeowner = isHomeOwner;
        this._includeAgePension = p.getParamBoolean("IncludeAgePension");
        if ((singlePersonProjection && isMarried && allowForBothAgePensions)) {
            this._singlePersonProjectionButAllowForBothAgePensions = true;
        }
        else {
            this._singlePersonProjectionButAllowForBothAgePensions = false;
        }
    };
    AgePensionBasis.prototype.index = function (projectionRunAsAt, yearCount, thisMemberType) {
        var startThisProjectionYear;
        var countOfRecipients;
        var taperRate;
        var assetTestUpperThreshold;
        startThisProjectionYear = projectionRunAsAt.plus(yearCount - 1);
        this._maxFortnightlyPayment.index(yearCount);
        this._pensionSupplementMinimum.index(yearCount);
        this._pensionSupplementMaximum.index(yearCount);
        this._pensionSupplementUpperIncomeThreshold.index(yearCount);
        this._pensionSupplementUpperAssetThreshold.index(yearCount);
        this._deemingThreshold.index(yearCount);
        this._WorkBonus.index(yearCount);
        this._incomeTest.index(yearCount);
        this._assetTest.index(yearCount);
        if (this._isMarried) {
            countOfRecipients = 2;
        }
        else {
            countOfRecipients = 1;
        }
        taperRate = 3;
        assetTestUpperThreshold = this._assetTest.minimumThreshold +
            ((this._maxFortnightlyPayment.value + this._pensionSupplementMaximum.value) * countOfRecipients / taperRate * 1000);
        this._assetTest.resetValues(this._assetTest.minimumThreshold, assetTestUpperThreshold);
    };
    AgePensionBasis.prototype.calculateAgePension = function (subjectSalaryEarnings, subjectAttainedAgePensionAge, partnerSalaryEarnings, partnerAttainedAgePensionAge, superannuationAssets, indexedPensionIncome, FinancialAssets, IncomeOnFinancialAssets, NonFinancialAssets, IncomeOnNonFinancialAssets, IncomeWithNoBackingAssets, PersonalAssets) {
        var incomeForIncomeTestPurposes;
        var incomeTestProportion;
        var assetTestProportion;
        var agePensionAnnual;
        assetTestProportion = this._assetTest.getProportion(superannuationAssets + FinancialAssets + NonFinancialAssets + PersonalAssets);
        if (subjectAttainedAgePensionAge) {
            subjectSalaryEarnings = Math.max(subjectSalaryEarnings - (this._WorkBonus.value * Constants.FORTNIGHTS_PER_YEAR), 0);
        }
        if (partnerAttainedAgePensionAge) {
            partnerSalaryEarnings = Math.max(partnerSalaryEarnings - (this._WorkBonus.value * Constants.FORTNIGHTS_PER_YEAR), 0);
        }
        incomeForIncomeTestPurposes =
            subjectSalaryEarnings +
                partnerSalaryEarnings +
                IncomeOnNonFinancialAssets +
                indexedPensionIncome +
                IncomeWithNoBackingAssets +
                this.calculateDeemedIncome(superannuationAssets + FinancialAssets);
        incomeTestProportion = this._incomeTest.getProportion(incomeForIncomeTestPurposes);
        agePensionAnnual = this._maxFortnightlyPayment.value *
            Math.min(incomeTestProportion, assetTestProportion) * Constants.FORTNIGHTS_PER_YEAR;
        if (incomeTestProportion > 0 && assetTestProportion > 0) {
            agePensionAnnual = agePensionAnnual +
                Math.max(this._pensionSupplementMaximum.value * Math.min(incomeTestProportion, assetTestProportion), this._pensionSupplementMinimum.value)
                    * Constants.FORTNIGHTS_PER_YEAR;
        }
        return agePensionAnnual;
    };
    AgePensionBasis.prototype.calculateDeemedIncome = function (financialInvestments) {
        if (financialInvestments < this._deemingThreshold.value) {
            return financialInvestments * this._deemingRateLowerIncome;
        }
        else {
            return (this._deemingThreshold.value * this._deemingRateLowerIncome) +
                ((financialInvestments - this._deemingThreshold.value) * this._deemingRateHigherIncome);
        }
    };
    Object.defineProperty(AgePensionBasis.prototype, "includeAgePension", {
        get: function () {
            return this._includeAgePension;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgePensionBasis.prototype, "maximumFortnightlyAgePension", {
        get: function () {
            return this._maxFortnightlyPayment.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgePensionBasis.prototype, "pensionSupplement", {
        get: function () {
            return this._pensionSupplementMaximum.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgePensionBasis.prototype, "deemingThreshold", {
        get: function () {
            return this._deemingThreshold.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgePensionBasis.prototype, "incomeTestMinimumThreshold", {
        get: function () {
            return this._incomeTest.minimumThreshold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgePensionBasis.prototype, "incomeTestMaximumThreshold", {
        get: function () {
            return this._incomeTest.maximumThreshold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgePensionBasis.prototype, "assetTestMinimumThreshold", {
        get: function () {
            return this._assetTest.minimumThreshold;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgePensionBasis.prototype, "assetTestMaximumThreshold", {
        get: function () {
            return this._assetTest.maximumThreshold;
        },
        enumerable: true,
        configurable: true
    });
    return AgePensionBasis;
}());
exports.AgePensionBasis = AgePensionBasis;
//# sourceMappingURL=AgePensionBasis.js.map